import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query ProjectStatus($projectId: Int!) {
    project(id: $projectId) {
      id
      status
      errors
    }
  }
`;

export const queryProjectStatus = (projectId) =>
  executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
    },
  }).then(({ data }) => getSingleProp(data));
